export enum ServiceProgrammesFilterType {
  ASSETS = 'Asset',
  ASSET_VEHICLE_TYPE = 'Asset.Vehicle',
  ASSET_EQUIPMENT_TYPE = 'Asset.Equipment',
  ASSET_VEHICLE = 'Asset.VehicleId',
  ASSET_EQUIPMENT = 'Asset.EquipmentId',
  ASSET_MACHINE_TYPE = 'Asset.Machine',
  ASSET_MACHINE = 'Asset.MachineId'
}

export enum JobsFilterType {
  TYPE = 'Type',
  JOB_TYPE = 'Job.Type',
  ASSET_VEHICLE = 'Asset.VehicleId',
  ASSET_EQUIPMENT = 'Asset.EquipmentId',
  ASSET_MACHINE = 'Asset.MachineId',
  PRIORITY = 'Priority',
  STATUS = 'Status',
  ASSIGNED_EMPLOYEES = 'Employees',
  SCHEDULED_DATE = 'ScheduledAt',
  START_DATE = 'StartedAt',
  NEXT_TRIGGER_INFO_DUE_AT = 'NextTriggerInfo.DueAt',
  COMPLETION_DATE = 'CompletedAt',
  ASSET_TYPE = 'Asset.AssetType',
  VENDOR = 'WorkOrderVendorId',
  CREATED_AT = 'CreatedAt',
  REPORTER = 'IssueReporterId'
}

export enum FormsFilterType {
  TYPE = 'Type'
}

export enum JobSchedulesFilterType {
  JOB_TYPE = 'JobType',
  ASSET_TYPE = 'Asset.AssetType',
  ASSET_VEHICLE = 'Asset.VehicleId',
  ASSET_EQUIPMENT = 'Asset.EquipmentId',
  ASSET_MACHINE = 'Asset.MachineId',
  ASSIGNED_EMPLOYEES = 'Employees',
  VENDOR = 'WorkOrderVendorId',
  PRIORITY = 'Priority',
  MAINTENANCE_TYPE = 'MaintenanceTypes',
  NEXT_TRIGGER_DATE = 'NextTriggerInfo.NextTimeBasedTrigger'
}

export enum VendorFilterType {
  CATEGORY = 'Category',
  ASSET_TYPE = 'Asset.AssetType',
  ASSET_VEHICLE = 'Asset.VehicleId',
  ASSET_EQUIPMENT = 'Asset.EquipmentId',
  ASSET_MACHINE = 'Asset.MachineId'
}

export enum EmployeesFilterType {
  ID = 'Id',
  NAME = 'Name',
  EMAIL = 'Email',
  PHONE = 'Phone',
  ROLE = 'Roles',
  EMPLOYEE_STATUS = 'EmployeeStatus',
  EMPLOYEE_TYPE_ID = 'EmployeeTypeId',
  EMPLOYEE_STATUS_ID = 'EmployeeStatusId'
}

export enum MaintenanceTypeFilterType {
  ASSET_TYPE = 'AssetType'
}

export enum MachineFilterType {
  BRAND = 'Brand',
  TYPE = 'Type',
  YEAR = 'Year',
  MODEL = 'Model',
  STATUS = 'Status',
  ASSIGNEE = 'AssignedEmployeeId',
  OWNERSHIP = 'Ownership',
  COMMISSION_DATE = 'CommissionDate',
  DECOMMISSION_DATE = 'DecommissionDate'
}

export enum VehicleFilterType {
  ID = 'Id',
  MOT_DATE = 'FitnessValidUpto'
}

export enum MachineFilterType {
  ID = 'Id',
  MOT_DATE = 'FitnessValidUpto'
}

export enum DateFilterType {
  TIMESTAMP = 'Timestamp'
}

export enum JobTasksFilterType {
  DUE_AT = 'DueAt',
  STARTED_AT = 'StartedAt',
  COMPLETED_AT = 'CompletedAt',
  JOB_TYPE = 'Job.Type',
  JOB_STATUS = 'Job.Status',
  JOB_PRIORITY = 'Job.Priority'
}

export enum TaskTemplatesFilterType {
  TYPE = 'Type',
  EMPLOYEES_COUNT = 'EmployeesCount'
}
